<template lang="pug">
  .wrapper
    img.icon(:src="images.ChainIcon", alt="Chain")
    h1.info-title {{ $t('no_valid_users.page_unavailable') }}
    h2.info {{ $t('no_valid_users.contact_host') }}
</template>

<script>
import ChainIcon from '@/assets/images/chain.svg';

export default {
  name: 'no-valid-users',
  computed: {
    images() {
      return { ChainIcon };
    }
  }
};
</script>

<style scoped lang="scss">

@import "assets/styles/application.scss";

.info-title {
  color: $black-100;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  margin-top: 32px;
}

.info {
  color: $gray-900;
  text-align: center;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px; /* 133.333% */
  letter-spacing: 0.1px;
  margin-top: 16px;
}

.wrapper {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;

  .icon {
    width: 56px;
    height: 56px;
    flex-shrink: 0;
  }
}

</style>
